import { render, staticRenderFns } from "./loadingSkeleton.vue?vue&type=template&id=28155c30"
import script from "./loadingSkeleton.vue?vue&type=script&lang=js"
export * from "./loadingSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports